import { nsMerchantUser } from '@/app/i18n/namespaces';
import MERCHANT_USER_STATUS from '../enums/MerchantUserStatus';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    EMAIL: {
        key: 'email',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.email',
        namespace: nsMerchantUser,
        placeholder: 'filter.placeholder.email',
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    IS_ADMIN: {
        key: 'isAdmin',
        type: FIELD_TYPES.TEXT,
        entity: 'contract_access_user_role'
    },
    MERCHANT_PROFILE: {
        key: 'merchantProfile',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.profile',
        namespace: nsMerchantUser,
        prefix: 'profile.',
        enableSorting: false
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        namespace: nsMerchantUser,
        entity: 'keys.created_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        namespace: nsMerchantUser,
        entity: 'keys.updated_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    STATUS: {
        key: 'status',
        type: 'select',
        namespace: nsMerchantUser,
        prefix: 'contract_access_status_',
        entity: 'keys.status',
        filter: FILTER_TYPES.SELECT,
        enum: MERCHANT_USER_STATUS,
        enableSorting: true
    },
    LAST_LOGIN_AT: {
        key: 'lastLoginAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.last_login_at',
        namespace: nsMerchantUser,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    PROFILE_NAME: {
        key: 'name'
    },
    PROFILE_PERMISSIONS: {
        key: 'permissions'
    }
};